let lastScrollTop = 0;
const pillNav = document.querySelector('.mobile-pill-nav');
const scrollThreshold = 50; // Increased threshold to prevent flickering

if (pillNav) {
  window.addEventListener('scroll', () => {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollDiff = Math.abs(currentScrollTop - lastScrollTop);
    
    if (scrollDiff > scrollThreshold) {
      if (currentScrollTop > lastScrollTop) {
        // Scrolling down
        pillNav.classList.add('hide');
        pillNav.classList.remove('show');
      } else {
        // Scrolling up
        pillNav.classList.add('show');
        pillNav.classList.remove('hide');
      }
      
      lastScrollTop = currentScrollTop;
    }
  });
} 